module.exports = __webpack_public_path__ + "static/img/ppt.97eac614.svg";